/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import CreateIcon from '@material-ui/icons/Create';
import AddCircle from '@material-ui/icons/AddCircle';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import withStyles from '@material-ui/core/styles/withStyles';

import { form as FormStyle } from '../../style/form';
import EventDispatcher from '../../state/reducers/EventDispatcher';
import DesktopCreditCardForm  from './Desktop/DesktopCreditCardForm';
import DesktopBillingEditAdress  from './Desktop/DesktopBillingEditAdress';
import VIsmallcard from '../../assets/svg/VIsmallcard';
import MCsmallcard from '../../assets/svg/MCsmallcard';
import AXsmallcard from '../../assets/svg/AXsmallcard';
import DSsmallcard from '../../assets/svg/DSsmallcard';
import { formatPhoneNumber } from '../../utils/formater';
import { isEmpty } from '../../utils/object';

import configENV from '../../config';

const styles = ({ typography, palette }) => FormStyle(typography, palette);

const wordCase = (string) => string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();

const cardIcons = {
    VI: VIsmallcard,
    MC: MCsmallcard,
    AX: AXsmallcard,
    DS: DSsmallcard,
};

const {  PERSIST_KEY } = configENV;

class DesktopCreditCardAndBillingForm extends PureComponent {
    emptyBillingAddressTemplate = (handleClickEditBillingAddress, wallet) => (
        <>
            <h2>Billing Address
                <span className="link-button margin-left" role="presentation" onClick={() => handleClickEditBillingAddress([], wallet, 'desktop')}>
                    <AddCircle className="link-icon" />
                    <span className="link-label">Add</span>
                </span>
            </h2>
            <div className="">You do not have a billing address on file.</div>
        </>
    );

    billingAddressViewTemplate = (wallet, billingAddress, handleClickEditBillingAddress) => {
        const {
            countries, walletId,
        } = wallet;
        const [{
            Addresses, FirstName, LastName, PhoneNumber, EmployerName,
        }] = billingAddress;
        const [{
            AddressLineOne, AddressLineTwo, Country, StateProvince, PostalCode, City,
        }] = Addresses;
        return (
            FirstName ? (
                <table className="tableInfo">
                    <tbody>
                        <tr className="billingTitle">
                            <th>Billing Address</th>
                            {walletId ? (
                                <td>
                                    <span aria-hidden onClick={() => handleClickEditBillingAddress(billingAddress, wallet, 'desktop')} className="link-button">
                                        <CreateIcon className="link-icon" />
                                        <span className="link-label">Edit</span>
                                    </span>
                                </td>
                            ) : <td /> }
                        </tr>
                        <tr>
                            <th>Name:</th>
                            <td> {FirstName} {LastName}</td>
                        </tr>
                        <tr className={!EmployerName ? 'display-none' : ''}>
                            <th>Company Name:</th>
                            <td>{EmployerName}</td>
                        </tr>
                        <tr>
                            <th>Address:</th>
                            <td>{AddressLineOne}
                                {AddressLineTwo
                                    ? `, ${AddressLineTwo}`
                                    : ''}
                            </td>
                        </tr>
                        <tr>
                            <th>City, State, Zip Code:</th>
                            <td> {[
                                City, StateProvince, PostalCode,
                            ].join(', ')}
                            </td>
                        </tr>
                        <tr>
                            <th>Country</th>
                            <td> {
                                Country && !isEmpty(countries) ? countries.filter((c) => c.id === Country)[0].name : ''
                            }
                            </td>
                        </tr>
                        <tr>
                            <th>Phone</th>
                            <td>{formatPhoneNumber(PhoneNumber)}</td>
                        </tr>
                    </tbody>
                </table>
            ) : (
                this.emptyBillingAddressTemplate(handleClickEditBillingAddress, wallet)
            )
        );
    }

    creditCardViewTemplate = (props, billingAddress) => {
        const {
            modal: { content: wallet }, handleClickEditCreditCard, cardTypes,
        } = props;
        const { defaultCreditCard, countries } = wallet;
        let cardHolderName;
        let cardType;
        let expiryDate;
        let lastFourDigits;
        let subsIndicator;
        let selectedCardType;
        let IconType;
        let editSelectedWallet;
        // Switch to Add New Billing Address form with default credit card if FirstName is empty
        try {
            // eslint-disable-next-line object-curly-newline
            ({ cardHolderName, cardType, expiryDate, lastFourDigits, subsIndicator } = wallet.walletId ? wallet : defaultCreditCard);
            selectedCardType = cardType ? cardTypes.filter((c) => c.id === cardType) : [];
            IconType = cardType ? cardIcons[cardType] : '';
            editSelectedWallet = wallet.walletId ? { ...wallet } : { ...defaultCreditCard };
        } catch (e) {
            cardHolderName = '';
            cardType = [];
            expiryDate = '';
            lastFourDigits = '';
            subsIndicator = '';
            selectedCardType = '';
            IconType = '';
            editSelectedWallet = {};
        }

        if (!cardHolderName) return null;

        return (
            <table className="tableInfo">
                <tbody>
                    <tr className="billingTitle">
                        <th>Card Information</th>
                        <td>
                            <span aria-hidden className="link-button" onClick={() => handleClickEditCreditCard({ ...editSelectedWallet, billingAddress, countries }, 'desktop')}>
                                <CreateIcon className="link-icon" />
                                <span className="link-label">Edit</span>
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>Name on Card:</th>
                        <td> {cardHolderName}</td>
                    </tr>
                    <tr>
                        <th>Card Type:</th>
                        <td><div className="cardtype-name">{selectedCardType.length ? wordCase(selectedCardType[0].name) : ''}<div className="cardtype-icon"><IconType /></div></div></td>
                    </tr>
                    <tr>
                        <th>Card Number:</th>
                        <td>&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;
                            {lastFourDigits}
                        </td>
                    </tr>
                    <tr>
                        <th>Expiration Date:</th>
                        <td> {expiryDate}</td>
                    </tr>
                    <tr>
                        <th> </th>
                        <td>{subsIndicator === '1' ? (
                            <>
                                <span className="default-card no-margin">Default Card</span>
                                <span className="default-card-info">Used for Subscriptions &amp; Passport renewals</span>
                            </>
                        ) : ''}
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }

    render() {
        const {
            modal: { content: wallet, config }, handleClickEditBillingAddress,
        } = this.props;
        let { billingAddress } = wallet;
        const { defaultCreditCard } = wallet;
        const hasDefaultCard = typeof defaultCreditCard !== 'undefined';
        let cardHolderName;
        // Switch to Add New Billing Address form with default credit card if FirstName is empty
        try {
            ({ cardHolderName } = wallet.walletId ? wallet : defaultCreditCard);
        } catch (e) {
            cardHolderName = '';
        }

        billingAddress = !isEmpty(billingAddress) && billingAddress[0].FirstName ? billingAddress : [
            {
                Addresses: [
                    {
                        AddressLineOne: '',
                        AddressLineTwo: '',
                        Country: '',
                        StateProvince: '',
                        PostalCode: '',
                        City: '',
                    },
                ],
                FirstName: '',
                LastName: '',
                PhoneNumber: '',
                EmployerName: '',
            },
        ];
        const isBillingAddress = (config === 'AddBillingAddress' || config === 'EditBillingAddress');
        return (
            <div className={`mainBillingCard ${isBillingAddress ? 'editAddress' : ''} ${!cardHolderName ? 'no-card-info' : ''}`}>
                <div className="billLeftSide">
                    {isBillingAddress
                        ? this.creditCardViewTemplate(this.props, billingAddress) : <DesktopCreditCardForm hasDefaultCard={hasDefaultCard} />}
                </div>
                <div className="billRigthtSide">
                    {isBillingAddress ? <DesktopBillingEditAdress /> : this.billingAddressViewTemplate(wallet, billingAddress, handleClickEditBillingAddress)}
                </div>
            </div>
        );
    }
}

DesktopCreditCardAndBillingForm.propTypes = {
    modal: PropTypes.object.isRequired,
    handleClickEditBillingAddress: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        modal: newState.modal,
        addNewConfig: newState.addNewConfig,
        cardTypes: newState.cardtypes,
    };
};
const mapDispatchToProps = (dispatch) => ({
    handleClickEditBillingAddress: (address, wallet, template) => dispatch(EventDispatcher.handleClickEditBillingAddress(address, wallet, template)),
    // handleDesktopClickEditCreditCard: (walletInfo) => dispatch(EventDispatcher.handleDesktopClickEditCreditCard(walletInfo)),
    handleClickEditCreditCard: (walletAndBillingInfo, template) => dispatch(EventDispatcher.handleClickEditCreditCard(walletAndBillingInfo, template)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles)(DesktopCreditCardAndBillingForm));
